/**
 * Feature flags for the Kjør min… rollout.
 *
 * Legacy vehicle sandbox games stay behind SHOW_LEGACY_GAMES until the new
 * series ships; then they can be deleted.
 */
export const SHOW_LEGACY_GAMES =
  process.env.REACT_APP_SHOW_LEGACY_GAMES === 'true' ||
  process.env.VITE_SHOW_LEGACY_GAMES === 'true';

/** When true, every pluss tier level is unlocked (dev convenience). */
export const PLUSS_ALL =
  process.env.REACT_APP_PLUSS_ALL === 'true' ||
  process.env.VITE_PLUSS_ALL === 'true' ||
  process.env.NODE_ENV === 'development';
